/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import DialogConditionDTO, { MAP_CONDITION_FROM_WATSON } from '../../../dto/DialogConditionDTO';
import Button from '../../@base/Button';
import styles from './DialogNode.module.css';
import DialogNodeCondition from './DialogNodeCondition';

export const DialogConditionsController = (props) => {
  if (!props.dialogConditions) return <></>;

  const [conditionStatusValidation, setConditionStatusValidation] = useState({});

  const moreHandler = () => {
    const firstCondition = props.dialogConditions.length === 0;
    const newDialog = new DialogConditionDTO();
    if (firstCondition) newDialog.relationalOperator = null;
    props.setDialogConditions([...props.dialogConditions, newDialog]);
  };

  const justOneCondition = props.dialogConditions.length === 1;

  const updateConditionHandler = (index, condition) => {
    const isValidCondition = DialogConditionDTO.validate(condition);
    const statusConditionValidationChanged = {
      conditionStatusValidation,
      [index]: isValidCondition,
    };
    const isValidAllCondition = !Object.values(statusConditionValidationChanged).includes(false);
    setConditionStatusValidation(statusConditionValidationChanged);

    if (isValidAllCondition) {
      const dialogConditions = [...props.dialogConditions];
      dialogConditions[index] = { ...condition };
      props.setDialogConditions(dialogConditions);
      props.save(dialogConditions);
    }
  };

  const removeConditionHandler = (index) => {
    let dialogConditions = [...props.dialogConditions];
    dialogConditions = dialogConditions.filter((c, i) => i !== index);
    if (index === 0 && dialogConditions[0]) delete dialogConditions[0].relationalOperator;
    props.setDialogConditions(dialogConditions);
    props.save(dialogConditions);
  };

  const isInValidConditions = Object.values(conditionStatusValidation).includes(false);

  return (
    <div>
      <div className={styles.DialogSubList}>
        {props.dialogConditions.map(
          (condition, index) => {
            if (condition.type === MAP_CONDITION_FROM_WATSON.contextVariable) return;
            return (
              <DialogNodeCondition
                firstCondition={index === 0}
                justOneCondition={justOneCondition}
                key={condition.id}
                condition={condition}
                intents={props.intents}
                entities={props.entities}
                removeDisabled={isInValidConditions || props.disabled}
                updateCondition={(_condition) => updateConditionHandler(index, _condition)}
                removeCondition={() => removeConditionHandler(index)}
                isInValidAnyConditions={isInValidConditions}
              />
            );
          },
        )}
        {props.dialogConditions.length === 0 && (
          <div className={styles.WithoutConditions}>
            Adicione condições para que esse nó envie respostas.
          </div>
        )}

        <div>
          <Button
            small
            circle
            primary
            classes="more-item"
            onClick={moreHandler}
            disabled={props.disabled}
          >
            <i className="fa fa-plus" aria-hidden="true" />
          </Button>
        </div>
      </div>

    </div>
  );
};

export default DialogConditionsController;
